module.exports = __webpack_public_path__ + "img/ht.5efda060.svg";